import React from 'react';
import { Box } from '@mui/material';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { DatePickerProps } from './DatePicker.props';
import { gridShortDate } from '../../../../utilities';

export const DatePicker = ({ dateValue, handleChange, latestPossibleMarketDate }: DatePickerProps) => ({
  forceComponent: true,
  component: (
    <Box display="flex" justifyContent="center">
      <MuiDatePicker
        value={dateValue ? new Date(dateValue) : null}
        format="MM/dd/yyyy"
        onChange={change => handleChange(gridShortDate(change))}
        views={['year', 'month', 'day']}
        maxDate={latestPossibleMarketDate ? new Date(latestPossibleMarketDate.toISOString()) : undefined}
      />
    </Box>
  ),
});
